import { SubmitMembershipChange } from '../contracts';
import axios, { AxiosError } from 'axios';
import { createAxiosConfig } from '../apiHelpers';
import LogCannon from '@ace-clublabs/log-cannon';
import StatusCode from 'status-code-enum';

export const SubmitMembershipChangeApi =
  (endpoint: string): SubmitMembershipChange =>
  async ({ sessionId, tags, enforceAutopay }) => {
    try {
      const request = { sessionId, tags, enforceAutopay };
      const response = await axios.post(endpoint, request, createAxiosConfig(endpoint));

      LogCannon.blast('SubmitMembershipChangeApi success');
      return Promise.resolve(response.data);
    } catch (e: any | AxiosError) {
      const errorResponse = e?.response?.data?.error;
      LogCannon.blast('SubmitMembershipChangeApi error', errorResponse);
      return Promise.reject({
        status: 'error',
        error: {
          code: e?.response?.status || StatusCode.ServerErrorInternal,
          message: 'SubmitMembershipChangeApi failed',
          ...errorResponse,
        },
      });
    }
  };
